import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLiveData } from "../services/slices/liveDataSlice";
import { loadInitialData } from "./helpers/loadInitialData";

const useAppData = (isLoggedIn) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoggedIn) return;

    const run = async () => {
      try {
        await loadInitialData(dispatch);
      } catch (error) {
        console.error("Error loading app data:", error);
      } finally {
        document.querySelector("#index-loading").style.display = "none";
      }
    };

    run();
  }, [isLoggedIn]);

  const processLiveData = (data) => {
    let tags = {
      all: data,
    };

    // Normalize each tag so that the data always resides in data.latestRecord.
    Object.keys(tags.all).forEach((key) => {
      const tag = tags.all[key];
      if (tag.data) {
        // If latestRecord is missing but record exists, assign record to latestRecord.
        if (!tag.data.latestRecord && tag.data.record) {
          tag.data.latestRecord = tag.data.record;
          delete tag.data.record;
        }
      }
    });

    // Dispatch the normalized live data
    dispatch(setLiveData(tags.all));
  };

  return { processLiveData };
};

export default useAppData;
